// ** React Imports
import { ChangeEvent, MouseEvent, useState, useEffect } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import InputLabel from '@mui/material/InputLabel'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import Tooltip from "@mui/material/Tooltip";
import InformationOutline from 'mdi-material-ui/InformationOutline';
import Fade from '@mui/material/Fade';
import CircularProgress from '@mui/material/CircularProgress';
// ** Icons Imports
import Key from 'mdi-material-ui/Key'
import EyeOutline from 'mdi-material-ui/EyeOutline'
import EyeOffOutline from 'mdi-material-ui/EyeOffOutline'
import LockOpenOutline from 'mdi-material-ui/LockOpenOutline'

// ** Custom Components Imports
import CustomAvatar from 'src/@core/components/mui/avatar'
import { Formik, Form, Field, ErrorMessage, useFormik } from 'formik'
import CheckCircle from 'mdi-material-ui/CheckCircle'
import * as Yup from 'yup';
import YupPassword from 'yup-password'
import axios from '../services/ApiService'
import { ApplicationPaths } from '../components/api-authorization/ApiAuthorizationConstants'
YupPassword(Yup)


interface State {
    fnameTooltipShow: boolean
    lnameTooltipShow: boolean
    pwTooltipShow: boolean
    newPassword: string
    showNewPassword: boolean,
    fnameToolTipContent: string,
    lnameToolTipContent: string,
    pwToolTipContent: string,
    showPwInfoToolTip: boolean,
    showTitleInfoToolTip: boolean
}

const IntroductionForm = () => {
    // ** States
    const [introFormvalues, setIntroFormValues] = useState<State>({
        fnameTooltipShow: false,
        lnameTooltipShow: false,
        pwTooltipShow: false,
        newPassword: '',
        showNewPassword: false,
        fnameToolTipContent: '',
        lnameToolTipContent: '',
        pwToolTipContent: '',
        showPwInfoToolTip: false,
        showTitleInfoToolTip: false

    })

    const handleClickShowNewPassword = () => {
        setIntroFormValues({ ...introFormvalues, showNewPassword: !introFormvalues.showNewPassword })
    }
    const handleMouseDownNewPassword = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
    }

    const SignupSchema = Yup.object().shape({
        firstName: Yup.string()
            .required('fnamerequired'),
        lastName: Yup.string()
            .required('lnamerequired'),
        password: Yup.string().password().min(
            8,
            'pwcharcount'
        ).minUppercase(1, 'pwuppercasecount')
            .minNumbers(1, 'pwnumbercount')
            .minSymbols(1, 'pwsymmbolcount')
        //.required('pwrequired')
    });

    const validateFullSchema = async () => {
        try {
            const results = await SignupSchema.validate(
                {
                    password: formik.values.password,
                    firstName: formik.values.firstName,
                    lastName: formik.values.lastName
                },
                { abortEarly: false }
            );
            createValidationTooltip([], true);
            console.log(`Results - ${results}`);
        } catch (e: any) {
            createValidationTooltip(e.errors, true);
            /*            console.log(`Error - ${e.errors}`);*/
        }
    }

    const createValidationTooltip = (errors: [], showTooltip?: boolean) => {
        const messages = {
            'fnamerequired': "First Name is required field",
            'lnamerequired': "Last Name is required field",
            'pwcharcount': "At least 8 characters",
            'pwuppercasecount': "1 Uppercase",
            'pwnumbercount': "1 Number",
            'pwsymmbolcount': "1 special character",
            //'pwrequired': "Password is Required",
        };
        if (errors) {
            let presentableErrors: any = errors.reduce((er, v) => ({ ...er, [v]: v }), {})
            /*            if (presentableErrors["pwcharcount"] || presentableErrors["pwuppercasecount"] || presentableErrors["pwnumbercount"] || presentableErrors["pwsymmbolcount"] || presentableErrors["pwrequired"]) {*/
            let pwMessages = [];
            let pwContent = {};
            let fnameContent = {};
            let lnameContent = {};
            let pwValidationpassed = true;
            if (presentableErrors["pwcharcount"]) {
                pwMessages.push({ message: messages["pwcharcount"], passed: false });
                pwValidationpassed = false;
            }
            else {
                pwMessages.push({ message: messages["pwcharcount"], passed: true });
            }
            if (presentableErrors["pwuppercasecount"]) {
                pwMessages.push({ message: messages["pwuppercasecount"], passed: false });
                pwValidationpassed = false;
            }
            else {
                pwMessages.push({ message: messages["pwuppercasecount"], passed: true });
            }
            if (presentableErrors["pwnumbercount"]) {
                pwMessages.push({ message: messages["pwnumbercount"], passed: false });
                pwValidationpassed = false;
            }
            else {
                pwMessages.push({ message: messages["pwnumbercount"], passed: true });
            }
            if (presentableErrors["pwsymmbolcount"]) {
                pwMessages.push({ message: messages["pwsymmbolcount"], passed: false });
                pwValidationpassed = false;
            }
            else {
                pwMessages.push({ message: messages["pwsymmbolcount"], passed: true });
            }
            //if (presentableErrors["pwrequired"]) {
            //    pwMessages.push({ message: messages["pwrequired"], passed: false });
            //}
            //else {
            //    pwMessages.push({ message: messages["pwrequired"], passed: true });
            //}
            if (pwValidationpassed) {
                setTimeout(() => setIsOpen(false), 500);
            }
            else {
                if (!!formik.touched.password)
                {
                    setIsOpen(true);
                }
            }
            pwContent = { pwToolTipContent: getValidationMessageHtml(pwMessages), pwTooltipShow: showTooltip ? true : false };
            //setIntroFormValues({ ...introFormvalues, })
            //}
            if (presentableErrors["fnamerequired"]) {
                //setIntroFormValues({ ...introFormvalues, fnameToolTipContent: getValidationMessageHtml(new Array({ message: messages["fnamerequired"], passed: false })), fnameTooltipShow: showTooltip ? true : false })
                fnameContent = { fnameToolTipContent: getValidationMessageHtml(new Array({ message: messages["fnamerequired"], passed: false })), fnameTooltipShow: showTooltip ? true : false };
            }
            else {
                //setIntroFormValues({ ...introFormvalues, fnameToolTipContent: getValidationMessageHtml(new Array({ message: messages["fnamerequired"], passed: true })), fnameTooltipShow: showTooltip ? true : false })
                fnameContent = { fnameToolTipContent: getValidationMessageHtml(new Array({ message: messages["fnamerequired"], passed: true })), fnameTooltipShow: showTooltip ? true : false };
            }
            if (presentableErrors["lnamerequired"]) {
                //setIntroFormValues({ ...introFormvalues, lnameToolTipContent: getValidationMessageHtml(new Array({ message: messages["lnamerequired"], passed: false })), lnameTooltipShow: showTooltip ? true : false })
                lnameContent = { lnameToolTipContent: getValidationMessageHtml(new Array({ message: messages["lnamerequired"], passed: false })), lnameTooltipShow: showTooltip ? true : false };
            }
            else {
                //setIntroFormValues({ ...introFormvalues, lnameToolTipContent: getValidationMessageHtml(new Array({ message: messages["lnamerequired"], passed: true })), lnameTooltipShow: showTooltip ? true : false })
                lnameContent = { lnameToolTipContent: getValidationMessageHtml(new Array({ message: messages["lnamerequired"], passed: true })), lnameTooltipShow: showTooltip ? true : false };
            }
            setIntroFormValues({ ...introFormvalues, ...pwContent, ...fnameContent, ...lnameContent });
        }
    }

    const getValidationMessageHtml = (messages: any[]) => {
        let htmlResult = '';
        messages.map((o, i) => {
            if (o.passed) {
                htmlResult += `<svg class="foreground" ng-style="{top: ae.offsetIcon+'px',left:ae.offsetIcon+'px',width:ae.size+'px',height:ae.size+'px',opacity:ae.foregroundOpacity}" viewBox="0 0 24 24" style="top: 116px; left: 116px; width: 24px; height: 24px; opacity: 1;">
                            <path ng-attr-fill="{{ae.foregroundColor.hex}}" ng-attr-d="{{icon.data}}" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#50c84c"></path>
                        </svg> ${o.message} <br/>`
            }
            else {
                htmlResult += `<svg class="foreground" ng-style="{top: ae.offsetIcon+'px',left:ae.offsetIcon+'px',width:ae.size+'px',height:ae.size+'px',opacity:ae.foregroundOpacity}" viewBox="0 0 24 24" style="top: 116px; left: 116px; width: 24px; height: 24px; opacity: 1;">
                                    <path ng-attr-fill="{{ae.foregroundColor.hex}}" ng-attr-d="{{icon.data}}" fill="#757575" d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"></path>
                                </svg> ${o.message}<br/>`
            }

        })
        return htmlResult;
    }

    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            password: '',
            title: ''
        },
        validationSchema: SignupSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            axios.post('userprofile', JSON.stringify(values)).then((response) => {
                setSubmitting(false);
                window.location.replace(ApplicationPaths.Login);
            });
        }
    });

    useEffect(() => {
        validateFullSchema();
    }, [formik.values]);

    const [IsOpen, setIsOpen] = useState(false);
    return (<>
        <form onSubmit={formik.handleSubmit}>
            <CardContent sx={{ minHeight: 500, display: formik.isSubmitting ? 'none' : 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                        <h1>
                            Complete Setting up your account
                        </h1>
                    </Grid>
                    <Grid item xs sx={{ mt: 5, mb: [0, 6] }}></Grid>
                    <Grid item sm={3} sx={{ mt: 5, mb: [0, 6] }}>
                        <Grid container spacing={6}>
                            <Grid item xs={12} >
                                <FormControl fullWidth>
                                    <Tooltip
                                        title={<div dangerouslySetInnerHTML={{ __html: introFormvalues.fnameToolTipContent }} />} open={!!formik.errors.firstName && !!formik.touched.firstName} placement="top" arrow={true}>
                                        <TextField
                                            id='outlined-basic'
                                            label='Your first name'
                                            placeholder={"Enter your first name"}
                                            name="firstName"
                                            onChange={(e) => {
                                                formik.handleChange(e)
                                                //validateFullSchema();
                                            }}
                                            value={formik.values.firstName || ""}
                                            onBlur={formik.handleBlur}
                                            inputProps={{
                                                form: {
                                                    autocomplete: 'off',
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Tooltip
                                    title={"Log in with either a password or password-less login where we send you a code each time you log in. This can be changed later."} open={introFormvalues.showPwInfoToolTip}
                                    placement="top"
                                    arrow={true}
                                >
                                    <IconButton color='inherit' aria-haspopup='true' onMouseEnter={() => setIntroFormValues({ ...introFormvalues, showPwInfoToolTip: true })}
                                        onMouseLeave={() => setIntroFormValues({ ...introFormvalues, showPwInfoToolTip: false })}
                                    > {/*onClick={handleModeToggle}*/}
                                        <InformationOutline />
                                    </IconButton>
                                </Tooltip>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor='account-settings-new-password'>Password (optional)</InputLabel>
                                    <Tooltip
                                        title={<div dangerouslySetInnerHTML={{ __html: introFormvalues.pwToolTipContent }} />}
                                        open={IsOpen}
                                        placement="bottom"
                                        arrow={true}                                        
                                    >
                                        <OutlinedInput
                                            label='Password (optional)'
                                            placeholder={"Enter a password"}
                                            id='account-settings-new-password'
                                            onChange={async (e) => {
                                                await formik.handleChange(e)
                                                //validateFullSchema();
                                            }}
                                            value={formik.values.password || ""}
                                            onBlur={formik.handleBlur}
                                            inputProps={{
                                                autocomplete: 'off',
                                                form: {
                                                    autocomplete: 'off',
                                                }
                                            }}
                                            //onChange={handleNewPasswordChange('newPassword')}
                                            onClick={() => { validateFullSchema(); setIsOpen(true) }}
                                            onFocus={() => { validateFullSchema(); setIsOpen(true) }}
                                            name="password"
                                            type={introFormvalues.showNewPassword ? 'text' : 'password'}
                                        />
                                        </Tooltip>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={3} sx={{ mt: 5, mb: [0, 6] }}>
                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Tooltip
                                        title={<div dangerouslySetInnerHTML={{ __html: introFormvalues.lnameToolTipContent }} />} open={!!formik.errors.lastName && !!formik.touched.lastName}
                                        placement="top"
                                        arrow={true}
                                    >
                                        <TextField
                                            id='outlined-basic'
                                            label='Your last name'
                                            placeholder={"Enter your last name"}
                                            name="lastName"
                                            onChange={async (e) => {
                                                await formik.handleChange(e)
                                                //validateFullSchema();
                                            }}
                                            value={formik.values.lastName || ""}
                                            onBlur={formik.handleBlur}
                                            inputProps={{
                                                form: {
                                                    autocomplete: 'off',
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Tooltip
                                    title={"A title could be specified if a group is performing social media management"} open={introFormvalues.showTitleInfoToolTip}
                                    placement="top"
                                    arrow={true}
                                >
                                    <IconButton color='inherit' aria-haspopup='true' onMouseEnter={() => setIntroFormValues({ ...introFormvalues, showTitleInfoToolTip: true })}
                                        onMouseLeave={() => setIntroFormValues({ ...introFormvalues, showTitleInfoToolTip: false })}
                                    > {/*onClick={handleModeToggle}*/}
                                        <InformationOutline />
                                    </IconButton>
                                </Tooltip>
                                <FormControl fullWidth>
                                    <TextField
                                        id='outlined-basic'
                                        label='Title (optional)'
                                        placeholder={"Enter your title"}
                                        name="title"
                                        onChange={formik.handleChange}
                                        value={formik.values.title || ""}
                                        onBlur={formik.handleBlur}
                                        inputProps={{
                                            form: {
                                                autocomplete: 'off',
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs sx={{ mt: 5, mb: [0, 6] }}></Grid>
                    <Grid item xs={12} sx={{ textAlign: "center" }}>
                        <Button size='large' type='submit' variant='contained' sx={{ width: '20%' }} onClick={validateFullSchema}>
                            Complete
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </form>
        {
            formik.isSubmitting && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 4rem)' }}>
                <Box>
                    <Fade
                        in={formik.isSubmitting}
                        style={{
                            transitionDelay: formik.isSubmitting ? '800ms' : '0ms',
                        }}
                        unmountOnExit
                    >
                        <CircularProgress />
                    </Fade>
                </Box>
            </Box>
        }

    </>
    )
}
export default IntroductionForm
